export default [
  {
    resource: "administration",
    header: "Eines",
  },
  {
    action: "manage",
    resource: "administration",
    icon: "CreditCardIcon",
    title: "Generador TPV",
    route: "foravila-tools-tpv-generator",
  },
];
